import { render, staticRenderFns } from "./list.vue?vue&type=template&id=1599abec&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1599abec')) {
      api.createRecord('1599abec', component.options)
    } else {
      api.reload('1599abec', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=1599abec&", function () {
      api.rerender('1599abec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companies/list.vue"
export default component.exports